import Review from "../../models/Review";
import styles from "./ReviewCard.module.css";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

interface ReviewCardProps {
  review: Review;
}

function ReviewCard({ review }: ReviewCardProps) {
  return (
    <article className={`rounded-4 ${styles.reviewCard}`}>
      <header className={styles.header}>
        <div className={styles.profileImageWrapper}>
          <img
            className={styles.profileImage}
            src={review.profileImageUri}
            alt={`${review.authorName}'s profile`}
          />
        </div>

        <p className={styles.authorName}>{review.authorName}</p>

        <a
          className={styles.sourceLink}
          href={review.reviewUri}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Read ${review.authorName}'s review on ${review.source}`}
        >
          <img
            className={styles.sourceIcon}
            src="/images/google-icon.png"
            alt="Google review source"
          />
        </a>
      </header>

      <div className={styles.meta}>
        <div
          className={styles.stars}
          aria-label={`${review.rating} out of 5 stars`}
        >
          {renderStars(review.rating)}
        </div>

        <p className={styles.date}>{review.date}</p>
      </div>

      <div className={styles.reviewContent}>
        <p className={styles.truncateMultiline}>{review.content}</p>

        <a
          href={review.reviewUri}
          target="_blank"
          rel="noopener noreferrer"
        >
          Read more
        </a>
      </div>
    </article>
  );
}

function renderStars(rating: number) {
  const safeRating = Math.max(0, Math.min(5, rating));
  const fullStars = Math.floor(safeRating);
  const hasHalfStar = safeRating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return [
    ...Array.from({ length: fullStars }, (_, index) => (
      <FaStar key={`full-${index}`} aria-hidden="true" />
    )),
    ...(hasHalfStar
      ? [<FaStarHalfAlt key="half" aria-hidden="true" />]
      : []),
    ...Array.from({ length: emptyStars }, (_, index) => (
      <FaRegStar key={`empty-${index}`} aria-hidden="true" />
    )),
  ];
}

export default ReviewCard;